import React from 'react';
import { Radio } from 'components';
import { SaveUpBadge } from './SaveUpBadge';

type BillingCycleChooserProps = {
  billingCycle: 'monthly' | 'yearly';
  editable: boolean;
  isMobile: boolean;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const billingTextMap = {
  yearly: 'Annual',
  monthly: 'Monthly',
};

export const BillingCycleChooser = ({
  billingCycle,
  onChange,
  editable,
  disabled,
  isMobile,
}: BillingCycleChooserProps) => {
  return (
    <div className='flex justify-between my-4'>
      <div className='text-black flex justify-end items-center font-extrabold text-17'>
        Billing Cycle
      </div>
      <div
        className={`flex justify-end items-start w-2/3 ${
          disabled ? 'cursor-not-allowed' : ''
        }`}
      >
        {editable ? (
          <div className={`${isMobile ? 'flex' : 'flex-center'} gap-4`}>
            <div className={isMobile ? 'flex flex-col' : 'flex-center'}>
              <Radio
                onChange={onChange}
                disabled={disabled}
                label={<div>Annual</div>}
                id='annual'
                labelsAlignment='justify'
                groupName='materials'
                value='yearly'
                size='small'
                checked={billingCycle === 'yearly'}
              />
              <SaveUpBadge />
            </div>

            <Radio
              onChange={onChange}
              disabled={disabled}
              className={isMobile ? '' : 'flex-center'}
              id='monthly'
              labelStyle={
                isMobile
                  ? {
                      height: 'fit-content',
                    }
                  : {}
              }
              label={<div className={isMobile ? 'py-2' : ''}>Monthly</div>}
              labelsAlignment='justify'
              groupName='materials'
              value='monthly'
              size='small'
              checked={billingCycle === 'monthly'}
            />
          </div>
        ) : (
          <p className='text-black font-extrabold text-17'>
            {billingTextMap[billingCycle]}
          </p>
        )}
      </div>
    </div>
  );
};
